import {createActions} from 'redux-actions';
import uiActions from '../chrome/ui.actions';

const actions = createActions('CONFIRMATION_OPEN', 'CONFIRMATION_CLOSE');

const actionHandler = handler => () => (dispatch, getState) => {
	const confirmation = getState().confirmation;
	if (confirmation[handler]) confirmation[handler](confirmation.data);
	dispatch(actions.confirmationClose());
	dispatch(uiActions.uiModal(null));
};

export default {
	...actions,
	open: payload => dispatch => {
		dispatch(actions.confirmationOpen(payload));
		dispatch(uiActions.uiModal('confirm'));
	},
	confirm: actionHandler('onConfirm'),
	cancel: actionHandler('onCancel'),
	continue: actionHandler('onContinue'),
	later: actionHandler('onLater'),
	yes: actionHandler('onYes'),
	no: actionHandler('onNo')
};



// WEBPACK FOOTER //
// ./src/widgets/confirmation.actions.js